var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"app-checkbox large",attrs:{"type":"checkbox"}})
}
var staticRenderFns = []

export { render, staticRenderFns }